
export default function WhatWeDo() {
  const services = [
    {
      icon: 'ri-megaphone-line',
      title: 'Lead Generation',
      description:
        'We run targeted Meta ads to attract homeowners actively searching for house extensions and loft conversions in your service area.',
    },
    {
      icon: 'ri-customer-service-line',
      title: 'Enquiry Handling',
      // Use double quotes for the outer string so the apostrophe inside doesn't break the syntax
      description:
        "Every call and enquiry is answered promptly. We ensure no lead is missed, even when you're on-site or unavailable.",
    },
    {
      icon: 'ri-mail-send-line',
      title: 'Automated Follow-Up',
      description:
        'We send timely follow-up messages via text and email to keep homeowners engaged until they\'re ready to speak with you.',
    },
    {
      icon: 'ri-user-star-line',
      title: 'Qualified Leads',
      description:
        'We filter and qualify enquiries so you only speak to homeowners who are serious about their project and ready to move forward.',
    },
  ];

  return (
    <section id="what-we-do" className="py-20 px-6 bg-[#F8FAFC]">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-6xl font-bold text-[#1a2947] mb-6">
            What <span className="text-[#2B5797]">We</span> Do
          </h2>
          <p className="text-xl text-[#334155] max-w-3xl mx-auto leading-relaxed">
            We take care of the entire lead generation and enquiry management process, so you can focus on building exceptional extensions and conversions.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 text-center shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-200"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-[#4A6FA5] rounded-full mx-auto mb-6 shadow-md">
                <i className={`${service.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-[#334155] mb-4">{service.title}</h3>
              <p className="text-lg text-[#334155]/70 leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
